var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('descricao-envelope'),_c('envelope-animacao',{on:{"exibir-lista-pdf":_vm.exbirListaPdf}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }